import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getGroupHierarchies(queryString, groupIds) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/hierarchies?" + queryString, { params: { groupIds: groupIds } }, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching hierarchies"
                    });
                }
            });
    },
    getAllNonDeletedGroups() {
        return axios.get(constants.BASE_URL + "/hierarchies/active-groups", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getHierarchyInfo(id) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/hierarchies/" + id, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching hierarchy info"
                    });
                }
            });
    }, updateState(id, deletedReason) {
        axios.defaults.withCredentials = true;
        return axios.put(constants.BASE_URL + "/hierarchies/" + id + "?deleteReason=" + deletedReason).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }, saveHierarchy(appDto) {
        axios.defaults.withCredentials = true;
        return axios.put(constants.BASE_URL + "/hierarchies", appDto).then(response => {
            return response.data;

        }).catch(error => {
           return error.response.data;
        });
    }, getActiveGroups() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/usersgroups/groupsAPI/getActiveGroups", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching active groups"
                    });
                }
            });
    }, addGroupToHierarchy(appDto) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/hierarchies", appDto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    getHierarchy(id) {
        return axios.get(constants.BASE_URL + "/hierarchies/" + id + "/initdata", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    removeGroupFromHierarchy(id) {
        return axios.delete(constants.BASE_URL + "/hierarchies/" + id, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    }, getGroupsNotInHierarchy(hierarchyId) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/usersgroups/groupsAPI/getGroupsNotInHierarchy?hierarchyId=" + hierarchyId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            });
    }, addNewParentGroup(id, appDto) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/hierarchies/" + id + "/new-parent-group", appDto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }, updateParent(childId, parentId) {
        var msgType = "updateSuccess";
        return axios.put(constants.BASE_URL + "/hierarchies/" + childId + "/parents/" + parentId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            });
    }

}
